<template>
    <el-drawer
        :before-close="cancel"
        :title="`${detail.name}`"
        :visible.sync="dialogVisible"
        :wrapperClosable="true"
        center
        class="dialog-container flex flex-direction"
        direction="rtl"
        size="700px">
        <div class="dialog-content flex flex-direction padding-lr-sm flex-sub">
            <div class="flex flex-direction flex-sub" v-if="detail">
                <div class="flex align-center justify-between">
                    <div class="text-black text-df"><i class="iconfont icon-vertical_line text-black text-bold text-df"></i>{{ detail.p_name }}</div>
                    <div class="flex align-center">
                        <div class="text-xs margin-right-xs">优先级</div>
                        <el-tag :type="detail.level | level_color" class="task-tag radius">{{ detail.level | level }}
                        </el-tag>
                    </div>
                </div>
                <div class="bg-red padding-sm radius margin-top-sm text-sm text-white" v-if="detail.state === 5 || detail.state === 9">
                    拒绝原因：<span class="text-bold">{{ detail.reason }}</span>
                </div>
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form  padding-sm radius margin-top-sm" labelWidth="auto">
                    <el-form-item label="负责人" prop="t_mid">
                        <div>{{ detail.fuzeren }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="成员" prop="join_mid_str">
                        <div>{{ detail.join_mid }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="分值" prop="join_mid_str">
                        <div>{{ detail.is_outside ? '--' : detail.score }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="时间" prop="end_time">
                        <div>{{ detail.end_time }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item label="描述" prop="desc">
                        <div>{{ detail.desc || '--' }}</div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.file.length" class="document" label="附件" prop="file">
                        <div class="flex margin-bottom-sm">
                            <div class="flex-sub flex flex-direction">
                                <div v-for="(item,index) in detail.file" :key="index" class="flex align-center">
                                    <div :href="item.url" class="file-name flex-sub ovHide text-sm" target="_blank" @click="toFilePreview(item.name,item.url)">
                                        <i class="el-icon-tickets margin-right-xs"></i>{{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-divider></el-divider>
                    </el-form-item>
                    <el-form-item v-if="detail.folder.length" label="需求佐证" prop="file">
                        <div class="flex">
                            <div class="flex-sub flex flex-direction">
                                <div v-for="(item,index) in detail.folder" :key="index" class="flex align-center justify-between">
                                    <div class="flex-sub ovHide cursor" @click="addFile(item)">
                                        <i class="iconfont icon-24gf-folderOpen margin-right-xs"></i>{{ item.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="实际完成时间" prop="finish_time" v-if="is_task_finish || detail.finish_time">
                        <el-date-picker v-model="ruleForm.finish_time"
                                        format="yyyy 年 MM 月 dd 日"
                                        placeholder="请选择" type="date" value-format="yyyy-MM-dd" :disabled="!is_task_finish"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="自评得分" prop="self_assessment_score" v-if="(is_task_finish || detail.self_assessment_score) && !detail.is_outside">
                        <el-input-number v-model="ruleForm.self_assessment_score" placeholder="请输入" :controls="false" :max="detail.score || 0" :disabled="!is_task_finish"></el-input-number>
                    </el-form-item>
                    <el-form-item label="自评说明" prop="self_assessment" v-if="is_task_finish || detail.self_assessment">
                        <el-input v-model="ruleForm.self_assessment" :autosize="{ minRows: 3, maxRows: 3 }"
                                  placeholder="请输入" resize="none" type="textarea" :disabled="!is_task_finish">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="publish-form flex flex-direction padding-lr-sm padding-tb-xs radius margin-top-sm">
                    <div class="flex align-center justify-between">
                        <div class="text-black text-bold text-lg">任务动态</div>
                        <el-button type="text"><i class="el-icon-arrow-down text-df"></i></el-button>
                    </div>
                    <div v-for="(item,index) in detail.task_dynamic" :key="index" class="flex align-center justify-between margin-top-xs ">
                        <div class="title text-xs text-black padding-lr-sm">
                            <span>{{ item.member_name }}</span>{{ item.change_content }}
                        </div>
                        <div class="text-xs text-black">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
            <div class="foot-view"></div>
            <div v-if="is_task_finish" class="foot flex align-center justify-center">
                <el-button class="btn max radius" type="primary" @click="submitForm('ruleForm')">提交评审</el-button>
            </div>
        </div>
        <task-folder-dialog :dialog-visible="addFileDialog" :fid="cur_fid" :fname="cur_fname" :pname="detail.p_name" :tname="detail.name" @watchState="watchState"></task-folder-dialog>
    </el-drawer>
</template>

<script>
import {getTaskDetail, setTaskReview} from "@/api";
import {is_task_finish, level_color, levels} from "@/utils/const";
import TaskFolderDialog from "@/views/web/staff/components/TaskFolderDialog";
import {TOAST, toast, toFilePreview, zhDate} from "@/utils/utils";

export default {
    name: "TaskFinishDialog",
    components: {TaskFolderDialog},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        tid: { //任务id
            type: Number,
        },
    },
    data() {
        return {
            ruleForm: {
                finish_time: '',
                self_assessment_score: '',
                self_assessment: '',
            },
            detail: '',
            rules: {
                finish_time: [
                    {required: true, message: '请选择实际完成时间', trigger: 'blur'}
                ],
                self_assessment_score: [
                    {required: true, message: '请输入自评得分', trigger: 'blur'}
                ],
                self_assessment: [
                    {required: true, message: '请输入自评说明', trigger: 'blur'}
                ],
            },
            is_task_finish: true,
            addFileDialog: false,
            cur_fname: '',
            cur_fid: 0
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            if (this.tid) {
                let _data = await getTaskDetail(this.tid)
                _data.data.file = _data.data.file ? JSON.parse(_data.data.file) : []
                this.detail = _data.data
                this.is_task_finish = _data.data.is_operation === 1 && is_task_finish(_data.data.state)
                this.ruleForm = {
                    finish_time: _data.data.finish_time || zhDate(new Date()),
                    self_assessment_score: _data.data.self_assessment_score || 0,
                    self_assessment: _data.data.self_assessment || '',
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.setTaskReview();
                }
            });
        },
        async setTaskReview() {
            this.loading = true
            let _data = await setTaskReview(this.tid, this.ruleForm.finish_time, this.ruleForm.self_assessment_score, this.ruleForm.self_assessment)
            this.loading = false
            if (_data.status === 200) {
                this.$emit('watchState', true)
                toast(`提交成功`, TOAST.success)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        addFile(data) {
            this.cur_fname = data.name
            this.cur_fid = data.id
            this.addFileDialog = true
        },
        watchState() {
            this.cur_fid = 0
            this.addFileDialog = false
        },
        cancel() {
            this.$emit('watchState', false)
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        }
    },
    filters: {
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        },
    },
    watch: {
        tid() {
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    .publish-form {
        border: solid 1px #e6e6e6;

        .title {
            position: relative;

            &::before {
                position: absolute;
                content: '';
                width: 9px;
                height: 9px;
                border-radius: 9px;
                background-color: var(--blue);
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
}

</style>